function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["lang", "locale", "currency", "price", "installmentsCount"],
  _excluded2 = ["children", "merchant", "infoAttrName", "productType", "theme", "publicKey", "merchantCode", "styleConfig", "selector"],
  _excluded3 = ["shouldInheritBg", "partnerCharges"],
  _excluded4 = ["minPrice", "minLimit"];
function cov_2ji7egjwtv() {
  var path = "/app/src/context/store/app-provider.tsx";
  var hash = "c1ab2521bbfa202e18663806a4715ef0058c8b10";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/context/store/app-provider.tsx",
    statementMap: {
      "0": {
        start: {
          line: 77,
          column: 28
        },
        end: {
          line: 77,
          column: 51
        }
      },
      "1": {
        start: {
          line: 79,
          column: 21
        },
        end: {
          line: 79,
          column: 73
        }
      },
      "2": {
        start: {
          line: 81,
          column: 0
        },
        end: {
          line: 81,
          column: 42
        }
      },
      "3": {
        start: {
          line: 83,
          column: 29
        },
        end: {
          line: 86,
          column: 3
        }
      },
      "4": {
        start: {
          line: 84,
          column: 2
        },
        end: {
          line: 86,
          column: 3
        }
      },
      "5": {
        start: {
          line: 88,
          column: 42
        },
        end: {
          line: 88,
          column: 43
        }
      },
      "6": {
        start: {
          line: 95,
          column: 24
        },
        end: {
          line: 132,
          column: 2
        }
      },
      "7": {
        start: {
          line: 102,
          column: 33
        },
        end: {
          line: 132,
          column: 1
        }
      },
      "8": {
        start: {
          line: 134,
          column: 27
        },
        end: {
          line: 303,
          column: 1
        }
      },
      "9": {
        start: {
          line: 153,
          column: 6
        },
        end: {
          line: 153,
          column: 34
        }
      },
      "10": {
        start: {
          line: 154,
          column: 44
        },
        end: {
          line: 154,
          column: 68
        }
      },
      "11": {
        start: {
          line: 181,
          column: 6
        },
        end: {
          line: 181,
          column: 55
        }
      },
      "12": {
        start: {
          line: 183,
          column: 2
        },
        end: {
          line: 207,
          column: 5
        }
      },
      "13": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 196,
          column: 7
        }
      },
      "14": {
        start: {
          line: 209,
          column: 2
        },
        end: {
          line: 217,
          column: 5
        }
      },
      "15": {
        start: {
          line: 219,
          column: 24
        },
        end: {
          line: 222,
          column: 3
        }
      },
      "16": {
        start: {
          line: 220,
          column: 24
        },
        end: {
          line: 220,
          column: 67
        }
      },
      "17": {
        start: {
          line: 224,
          column: 24
        },
        end: {
          line: 296,
          column: 3
        }
      },
      "18": {
        start: {
          line: 225,
          column: 11
        },
        end: {
          line: 260,
          column: 5
        }
      },
      "19": {
        start: {
          line: 298,
          column: 2
        },
        end: {
          line: 302,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 83,
            column: 29
          },
          end: {
            line: 83,
            column: 30
          }
        },
        loc: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        },
        line: 84
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 95,
            column: 24
          },
          end: {
            line: 95,
            column: 25
          }
        },
        loc: {
          start: {
            line: 102,
            column: 33
          },
          end: {
            line: 132,
            column: 1
          }
        },
        line: 102
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 134,
            column: 27
          },
          end: {
            line: 134,
            column: 28
          }
        },
        loc: {
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 303,
            column: 1
          }
        },
        line: 148
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 183,
            column: 12
          },
          end: {
            line: 183,
            column: 13
          }
        },
        loc: {
          start: {
            line: 183,
            column: 18
          },
          end: {
            line: 197,
            column: 3
          }
        },
        line: 183
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 220,
            column: 4
          },
          end: {
            line: 220,
            column: 5
          }
        },
        loc: {
          start: {
            line: 220,
            column: 24
          },
          end: {
            line: 220,
            column: 67
          }
        },
        line: 220
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 225,
            column: 5
          }
        },
        loc: {
          start: {
            line: 225,
            column: 11
          },
          end: {
            line: 260,
            column: 5
          }
        },
        line: 225
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 136,
            column: 2
          },
          end: {
            line: 136,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 136,
            column: 13
          },
          end: {
            line: 136,
            column: 37
          }
        }],
        line: 136
      },
      "1": {
        loc: {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 150,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 150,
            column: 22
          },
          end: {
            line: 150,
            column: 27
          }
        }],
        line: 150
      },
      "2": {
        loc: {
          start: {
            line: 254,
            column: 16
          },
          end: {
            line: 254,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 254,
            column: 16
          },
          end: {
            line: 254,
            column: 24
          }
        }, {
          start: {
            line: 254,
            column: 28
          },
          end: {
            line: 254,
            column: 36
          }
        }],
        line: 254
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c1ab2521bbfa202e18663806a4715ef0058c8b10"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ji7egjwtv = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ji7egjwtv();
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useEffect, useMemo, useReducer } from 'react';
import { findExperiment } from 'src/checkout-frame/utils/find-experiment';
import { ACTIONS } from 'src/constants/common';
import { storeReducer } from 'src/context/store/store-reducer';
import { useValuesToBoolean } from 'src/context/store/use-values-to-boolean';
import { useValuesToNumber } from 'src/context/store/use-values-to-number';
import { useWidgetData } from 'src/hooks/use-widget-data';
import { Lang } from 'src/types/lang-locale-type';
import { checkCurrency, formatCurrency } from 'src/utils/check-currency';
import { checkInstallmentsCount } from 'src/utils/check-installments-count';
import { checkLang } from 'src/utils/check-lang';
import { checkLocale } from 'src/utils/check-locale';
import { checkPrice } from 'src/utils/check-price';
import { checkProductType } from 'src/utils/check-product-type';
import { checkTheme } from 'src/utils/check-theme';
export var defaultValue = (cov_2ji7egjwtv().s[0]++, {});
var StoreContext = (cov_2ji7egjwtv().s[1]++, /*#__PURE__*/React.createContext(defaultValue));
cov_2ji7egjwtv().s[2]++;
StoreContext.displayName = 'StoreContext';
cov_2ji7egjwtv().s[3]++;
export var useAppContext = function useAppContext() {
  cov_2ji7egjwtv().f[0]++;
  cov_2ji7egjwtv().s[4]++;
  return React.useContext(StoreContext);
};
export var INSTALLMENTS_COUNT_DEFAULT = (cov_2ji7egjwtv().s[5]++, 4);
cov_2ji7egjwtv().s[6]++;
var getInitialState = function getInitialState(_ref) {
  var lang = _ref.lang,
    locale = _ref.locale,
    currency = _ref.currency,
    price = _ref.price,
    installmentsCount = _ref.installmentsCount,
    other = _objectWithoutProperties(_ref, _excluded);
  cov_2ji7egjwtv().f[1]++;
  cov_2ji7egjwtv().s[7]++;
  return _objectSpread({
    lang: checkLang(lang, {
      locale: locale
    }),
    locale: checkLocale(locale, {
      lang: lang
    }),
    currency: checkCurrency(currency),
    formattedCurrency: formatCurrency(currency),
    price: checkPrice(price),
    priceRaw: price,
    installmentsCount: checkInstallmentsCount(INSTALLMENTS_COUNT_DEFAULT)(installmentsCount),
    installmentsCountRaw: installmentsCount,
    isBig: false,
    isDark: false,
    isBold: false,
    isMobileRounded: false,
    isShortSplitIt: false,
    experiments: [],
    entityId: '',
    aid: '',
    offers: {
      installments: []
    },
    learnMoreVisibility: {
      ltf: false,
      pix: false,
      pif: false,
      default: false
    },
    loading: true
  }, other);
};
cov_2ji7egjwtv().s[8]++;
export var AppProvider = function AppProvider(_ref2) {
  var children = _ref2.children,
    _ref2$merchant = _ref2.merchant,
    merchant = _ref2$merchant === void 0 ? (cov_2ji7egjwtv().b[0][0]++, document.location.origin) : _ref2$merchant,
    infoAttrName = _ref2.infoAttrName,
    productType = _ref2.productType,
    theme = _ref2.theme,
    publicKey = _ref2.publicKey,
    merchantCode = _ref2.merchantCode,
    styleConfig = _ref2.styleConfig,
    selector = _ref2.selector,
    propsRaw = _objectWithoutProperties(_ref2, _excluded2);
  cov_2ji7egjwtv().f[2]++;
  var _ref3 = (cov_2ji7egjwtv().s[9]++, useValuesToBoolean(propsRaw)),
    _ref3$shouldInheritBg = _ref3.shouldInheritBg,
    shouldInheritBg = _ref3$shouldInheritBg === void 0 ? (cov_2ji7egjwtv().b[1][0]++, false) : _ref3$shouldInheritBg,
    partnerCharges = _ref3.partnerCharges,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var _ref4 = (cov_2ji7egjwtv().s[10]++, useValuesToNumber(props)),
    minPrice = _ref4.minPrice,
    minLimit = _ref4.minLimit,
    values = _objectWithoutProperties(_ref4, _excluded4);
  var _ref5 = (cov_2ji7egjwtv().s[11]++, useReducer(storeReducer, values, getInitialState)),
    _ref6 = _slicedToArray(_ref5, 2),
    _ref6$ = _ref6[0],
    lang = _ref6$.lang,
    locale = _ref6$.locale,
    currency = _ref6$.currency,
    price = _ref6$.price,
    installmentsCount = _ref6$.installmentsCount,
    installmentsCountRaw = _ref6$.installmentsCountRaw,
    formattedCurrency = _ref6$.formattedCurrency,
    priceRaw = _ref6$.priceRaw,
    isBig = _ref6$.isBig,
    isDark = _ref6$.isDark,
    titles = _ref6$.titles,
    isBold = _ref6$.isBold,
    isMobileRounded = _ref6$.isMobileRounded,
    isShortSplitIt = _ref6$.isShortSplitIt,
    webview = _ref6$.webview,
    experiments = _ref6$.experiments,
    entityId = _ref6$.entityId,
    aid = _ref6$.aid,
    offers = _ref6$.offers,
    learnMoreVisibility = _ref6$.learnMoreVisibility,
    loading = _ref6$.loading,
    dispatch = _ref6[1];
  cov_2ji7egjwtv().s[12]++;
  useEffect(function () {
    cov_2ji7egjwtv().f[3]++;
    cov_2ji7egjwtv().s[13]++;
    dispatch({
      type: ACTIONS.UPDATE_STORE,
      payload: {
        isDark: values.isDark,
        isBig: values.isBig,
        titles: values.titles,
        installmentsCount: values.installmentsCount,
        price: values.price,
        currency: values.currency,
        lang: values.lang,
        locale: values.locale
      }
    });
  }, [dispatch, values.isDark, values.isBig, values.titles, values.installmentsCount, values.price, values.currency, values.lang, values.locale]);
  cov_2ji7egjwtv().s[14]++;
  useWidgetData({
    publicKey: publicKey,
    merchantCode: merchantCode,
    currency: currency,
    amount: price,
    webview: webview,
    dispatch: dispatch,
    loading: loading
  });
  var getExperiment = (cov_2ji7egjwtv().s[15]++, useCallback(function (experimentName) {
    cov_2ji7egjwtv().f[4]++;
    cov_2ji7egjwtv().s[16]++;
    return findExperiment(experimentName, experiments);
  }, [experiments]));
  var providerValue = (cov_2ji7egjwtv().s[17]++, useMemo(function () {
    var _ref7;
    cov_2ji7egjwtv().f[5]++;
    cov_2ji7egjwtv().s[18]++;
    return {
      selector: selector,
      isRtl: lang === Lang.ar,
      lang: lang,
      locale: locale,
      currency: currency,
      price: price,
      productType: checkProductType(productType),
      theme: checkTheme(theme),
      installmentsCount: installmentsCount,
      installmentsCountRaw: installmentsCountRaw,
      experiments: experiments,
      entityId: entityId,
      partnerCharges: partnerCharges,
      publicKey: publicKey,
      merchantCode: merchantCode,
      styleConfig: styleConfig,
      shouldInheritBg: shouldInheritBg,
      isBig: isBig,
      isDark: isDark,
      merchant: merchant,
      formattedCurrency: formattedCurrency,
      priceRaw: priceRaw,
      dispatch: dispatch,
      getExperiment: getExperiment,
      loading: loading,
      offers: offers,
      learnMoreVisibility: learnMoreVisibility,
      aid: aid,
      minPrice: (_ref7 = (cov_2ji7egjwtv().b[2][0]++, minPrice)) !== null && _ref7 !== void 0 ? _ref7 : (cov_2ji7egjwtv().b[2][1]++, minLimit),
      infoAttrName: infoAttrName,
      titles: titles,
      isBold: isBold,
      isMobileRounded: isMobileRounded,
      isShortSplitIt: isShortSplitIt
    };
  }, [selector, currency, experiments, entityId, getExperiment, installmentsCount, installmentsCountRaw, lang, locale, merchantCode, partnerCharges, price, productType, publicKey, shouldInheritBg, styleConfig, theme, isBig, isDark, merchant, formattedCurrency, priceRaw, loading, offers, learnMoreVisibility, aid, minPrice, minLimit, infoAttrName, titles, isBold, isMobileRounded, isShortSplitIt]));
  cov_2ji7egjwtv().s[19]++;
  return /*#__PURE__*/React.createElement(StoreContext.Provider, {
    value: providerValue
  }, children);
};